import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Field } from '../../../shared/ui/Field';
import { Button } from '../../../shared/ui/Button';
import { colors } from '../../../shared/styles/colors';
import {userStore} from '../../../entities/user/model/user-store';

const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
  max-width: 400px;
`;

const ErrorMessage = styled.div`
  color: ${colors.errorState};
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 4px;
`;

const resetPasswordEmailSchema = z.object({
  email: z.string().min(1, 'Email обов\'язковий').email('Введіть коректний email')
});

type ResetPasswordEmailFormValues = z.infer<typeof resetPasswordEmailSchema>;

export const ResetPasswordEmailForm = observer(() => {
  const navigate = useNavigate();
  const methods = useForm<ResetPasswordEmailFormValues>({
    resolver: zodResolver(resetPasswordEmailSchema),
    defaultValues: {
      email: ''
    }
  });

  const { handleSubmit, formState, setValue } = methods;

  const onSubmit = handleSubmit(async (data: ResetPasswordEmailFormValues) => {
    try {
      const success = await userStore.requestPasswordReset(data.email);
      if (success) {
        navigate('/auth/reset-password/check-email');
      }
    } catch (err) {
      methods.setError('root', {
        type: 'manual',
        message: 'Виникла помилка при відправці запиту на відновлення паролю'
      });
    }
  });

  return (
    <FormProvider {...methods}>
      <FormWrapper onSubmit={onSubmit}>
        <Field
          name="email"
          type="email"
          placeholder="E-mail *"
          error={formState.errors.email?.message}
          onChange={(e) => setValue('email', e.target.value)}
          isSuccessful={formState.isValid && formState.dirtyFields.email}
        />
        {formState.errors.email && (
          <ErrorMessage>{formState.errors.email.message}</ErrorMessage>
        )}
        {formState.errors.root && (
          <ErrorMessage>{formState.errors.root.message}</ErrorMessage>
        )}

        <Button
          type="submit"
          variant="primary"
          fullWidth
          // disabled={!formState.isValid}
        >
          Отримати лист на E-mail
        </Button>
        <Button
          onClick={() => navigate(-1)}
          variant="text"
          color={colors.accentPrimary}
          fullWidth
        >
          Назад
        </Button>
      </FormWrapper>
    </FormProvider>
  );
});
